<template>
  <b-form @submit.prevent="onSubmit" novalidate>
    <b-form-row class="align-items-center">
      <b-col md="12" lg="auto" xl="auto">
        {{ domain() }}
        <span class="ml-1">/</span>
      </b-col>
      <b-col>
        <b-form-input v-model="form.companySlug" :state="isValidField('companySlug')" placeholder="your-company-url" class="rounded-pill" />
      </b-col>
    </b-form-row>
    <b-form-invalid-feedback :state="isValidField('companySlug')" class="mt-3">
      <div v-for="error in errors.companySlug || []" :key="error">
        {{ error }}
      </div>
    </b-form-invalid-feedback>
    <p class="d-flex mt-4">
      <span class="mr-2">
        <b-icon-circle-fill font-scale=".7" />
      </span>
      <span>
        Please note: special requirements and warnings about the workspace url formatting (uppercase, lowercase etc)
      </span>
    </p>
    <b-form-row class="mt-5 justify-content-center">
      <b-col cols="auto">
        <b-button type="submit" :disabled="submitting" pill variant="primary" class="pl-5 pr-5">Connect</b-button>
      </b-col>
    </b-form-row>
  </b-form>

</template>

<script>
import validator from 'validator'
import { BIconCircleFill } from 'bootstrap-vue'
import MixinForm from './MixinForm'

export default {
  name: 'ConnectToWorkspaceForm',

  mixins: [MixinForm],

  data() {
    return {
      form: {
        companySlug: ''
      }
    }
  },

  methods: {
    domain() {
      return location.hostname
    },

    validate(data) {
      const errors = {}
      if (validator.isEmpty(data.companySlug)) errors.companySlug = ["Company url can't be blank"]
      return errors
    }
  },

  components: {
    BIconCircleFill
  }
}
</script>
